import { Elements, PaymentElement } from "@stripe/react-stripe-js";


Stripe.Element = (props) => <PaymentElement options={{ layout: "tabs" }} {...props} />;

export default function Stripe(props) { return <Elements {...props} />; }